import { type Language } from "../types/i18n";

import termsAndConditionsEn from "../assets/legal/termsAndConditions-en.md";
import termsAndConditionsBg from "../assets/legal/termsAndConditions-bg.md";

import privacyPolicyEn from "../assets/legal/privacyPolicy-en.md";
import privacyPolicyBg from "../assets/legal/privacyPolicy-bg.md";

import dataProcessingAgreementEn from "../assets/legal/dataProcessingAgreement-en.md";
import dataProcessingAgreementBg from "../assets/legal/dataProcessingAgreement-bg.md";

type LegalData = Record<
   Language,
   {
      body: string;
   }
>;

export const legal = {
   termsAndConditions: {
      en: termsAndConditionsEn,
      bg: termsAndConditionsBg,
   },
   privacyPolicy: {
      en: privacyPolicyEn,
      bg: privacyPolicyBg,
   },
   dataProcessingAgreement: {
      en: dataProcessingAgreementEn,
      bg: dataProcessingAgreementBg,
   },
} satisfies Record<string, LegalData>;
